import {Bundle} from "./bundle";

export class BundleCollection {
    constructor(api, popup) {
        const buttons = jQuery('.btn-buynow-bundle');
        for (let i = 0; i < buttons.length; ++i) {
            new Bundle(api, popup, buttons.eq(i));
        }
    }
}